<template>
  <div>

    <b-row class="mb-4">
      <b-col>
        <b-select v-model="week_id" :options="weekOptions" :disabled="busy" @input="onWeekChange"></b-select>
      </b-col>
    </b-row>

    <b-row>

      <b-col class="d-flex align-items-stretch mb-4">
        <b-card no-body class="datacandy-metric-card w-100">
          <b-card-body>
            <h4 class="text-uppercase text-secondary text-center">
              <i class="fa fa-fw fa-users"></i>
              {{ trans('active_members') }}
            </h4>
          </b-card-body>
          <b-card-body v-if="!busy && !weekly">
            <p class="lead text-center m-4 p-4 text-muted">
              {{ trans('no_data') }}
            </p>
          </b-card-body>
          <b-card-body v-if="busy">
            <p class="lead text-center m-4 p-4">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('please_wait') }}
            </p>
          </b-card-body>

          <b-card-body v-if="!!weekly && !busy">
            <b-row>
              <b-col class="text-center">
                <chart
                  :labels="pluck(chart_active_members, 'label')"
                  :data="pluck(chart_active_members, 'value')"
                  :tooltip_label_fn="partial(tooltipLabelFn, chart_active_members)"
                ></chart>
              </b-col>
              <b-col class="text-center">
                <two-metrics
                  :title="trans('active_members')"
                  :data="[weekly.active_members, weekly.monthly.active_members]"
                  :labels="[trans('weekly'), monthLabel]"
                ></two-metrics>
              </b-col>
            </b-row>
          </b-card-body>

        </b-card>
      </b-col>

      <b-col class="d-flex align-items-stretch mb-4">
        <b-card no-body class="datacandy-metric-card w-100">
          <b-card-body>
            <h4 class="text-uppercase text-secondary text-center">
              <i class="fa fa-fw fa-user-plus"></i>
              {{ trans('new_members') }}
            </h4>
          </b-card-body>
          <b-card-body v-if="!busy && !weekly">
            <p class="lead text-center m-4 p-4 text-muted">
              {{ trans('no_data') }}
            </p>
          </b-card-body>
          <b-card-body v-if="busy">
            <p class="lead text-center m-4 p-4">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('please_wait') }}
            </p>
          </b-card-body>

          <b-card-body v-if="!!weekly && !busy">
            <b-row class="h-100">
              <b-col class="text-center align-self-center">
                <chart
                  :labels="pluck(chart_new_members, 'label')"
                  :data="pluck(chart_new_members, 'value')"
                  :tooltip_label_fn="partial(tooltipLabelFn, chart_new_members)"
                ></chart>
              </b-col>
              <b-col class="text-center align-self-center">
                <two-metrics
                  :title="trans('new_members')"
                  :data="[weekly.new_members, weekly.monthly.new_members]"
                  :labels="[trans('weekly'), monthLabel]"
                ></two-metrics>
              </b-col>
            </b-row>
          </b-card-body>

        </b-card>
      </b-col>

    </b-row>

    <b-row>

      <b-col class="d-flex align-items-stretch mb-4">
        <b-card no-body class="datacandy-metric-card w-100">
          <b-card-body>
            <h4 class="text-uppercase text-secondary text-center">
              <i class="fa fa-fw fa-gas-pump"></i>
              {{ trans('pump') }}
            </h4>
          </b-card-body>
          <b-card-body v-if="!busy && !weekly">
            <p class="lead text-center m-4 p-4 text-muted">
              {{ trans('no_data') }}
            </p>
          </b-card-body>
          <b-card-body v-if="busy">
            <p class="lead text-center m-4 p-4">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('please_wait') }}
            </p>
          </b-card-body>

          <b-card-body v-if="!!weekly && !busy">
            <b-row>
              <b-col class="text-center">
                <chart
                  :labels="pluck(chart_total_volume, 'label')"
                  :data="pluck(chart_total_volume, 'value')"
                  :tooltip_label_fn="partial(tooltipLabelFn, chart_total_volume)"
                ></chart>
              </b-col>
              <b-col class="text-center">
                <two-metrics
                  :title="trans('fuel_pumped') + ' (L)'"
                  :data="[weekly.total_volume, weekly.monthly.total_volume]"
                  :labels="[trans('weekly'), monthLabel]"
                ></two-metrics>
              </b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col class="text-center mx-4">
                <two-metrics
                  :title="trans('pump_visits')"
                  :data="[weekly.fuel_visit, weekly.monthly.fuel_visit]"
                  :labels="[trans('weekly'), monthLabel]"
                ></two-metrics>
              </b-col>
              <b-col class="text-center mx-4">
                <two-metrics
                  :title="trans('basket_size') + ' (L)'"
                  :data="[weekly.vol_by_visit, weekly.monthly.vol_by_visit]"
                  :labels="[trans('weekly'), monthLabel]"
                ></two-metrics>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col class="d-flex align-items-stretch mb-4">
        <b-card no-body class="datacandy-metric-card w-100">
          <b-card-body>
            <h4 class="text-uppercase text-secondary text-center">
              <i class="fa fa-fw fa-shopping-basket"></i>
              {{ trans('instore') }}
            </h4>
          </b-card-body>
          <b-card-body v-if="!busy && !weekly">
            <p class="lead text-center m-4 p-4 text-muted">
              {{ trans('no_data') }}
            </p>
          </b-card-body>
          <b-card-body v-if="busy">
            <p class="lead text-center m-4 p-4">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('please_wait') }}
            </p>
          </b-card-body>

          <b-card-body v-if="!!weekly && !busy">
            <b-row>
              <b-col class="text-center">
                <chart
                  :labels="pluck(chart_total_spend, 'label')"
                  :data="pluck(chart_total_spend, 'value')"
                  :tooltip_label_fn="partial(tooltipLabelFn, chart_total_spend)"
                  format="0,000a$"
                ></chart>
              </b-col>
              <b-col class="text-center">
                <two-metrics
                  :title="trans('instore_spend')"
                  :data="[weekly.total_spend, weekly.monthly.total_spend]"
                  :labels="[trans('weekly'), monthLabel]"
                  format="0,000$"
                ></two-metrics>
              </b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col class="text-center mx-4">
                <two-metrics
                  :title="trans('instore_visits')"
                  :data="[weekly.store_visit, weekly.monthly.store_visit]"
                  :labels="[trans('weekly'), monthLabel]"
                ></two-metrics>
              </b-col>
              <b-col class="text-center mx-4">
                <two-metrics
                  :title="trans('basket_size')"
                  :data="[weekly.spend_by_visit, weekly.monthly.spend_by_visit]"
                  :labels="[trans('weekly'), monthLabel]"
                  format="0,000.00$"
                ></two-metrics>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

  </div>
</template>

<script>
  import Chart from './DatacandyChart'
  import TwoMetrics from './DatacandyTwoMetrics'

  function mapToChartData(weekly, attr) {
    let data = _.sortBy(weekly.previous, 'id').map(o => {
      return {
        week: o.week+1,
        label: `w${o.week+1}`,
        value: o[attr],
        start_date: o.start_date,
      }
    })
    data.push({
      week: weekly.week+1,
      label: `w${weekly.week+1}`,
      value: weekly[attr],
      start_date: weekly.start_date,
    })
    return data
  }

  export default {
    props: [
      'organization',
      'weeks',
    ],
    components: {
      Chart,
      TwoMetrics,
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
        moment: moment,
        partial: _.partial,
        pluck: _.map,
        error: null,
        busy: false,
        week_id: this.weeks && this.weeks.length > 0 ? this.weeks[0].week_id : null,
        weekly: null,
      }
    },
    computed: {
      monthLabel() {
        return _.camelCase(moment(this.weekly.monthly.start_date).format('MMMM'))
      },
      weekOptions() {
        return this.weeks.map(o => {
          const parts = o.week_id.split('-')
          const year = parts[0]
          const week = parseInt(parts[1], 10) + 1
          const date = moment(o.start_date).format('LL')
          return {
            text: `${year} ${trans('week').toLowerCase()} ${week} - ${date}`,
            value: o.week_id,
          }
        })
      },
      delta_active_members() {
        return this.weekly.delta ? this.weekly.delta.active_members : null
      },
      monthly_delta_active_members() {
        return this.weekly.monthly && this.weekly.monthly.delta ? this.weekly.monthly.delta.active_members : null
      },
      chart_active_members() {
        return mapToChartData(this.weekly, 'active_members')
      },
      chart_new_members() {
        return mapToChartData(this.weekly, 'new_members')
      },
      chart_total_volume() {
        return mapToChartData(this.weekly, 'total_volume')
      },
      chart_total_spend() {
        return mapToChartData(this.weekly, 'total_spend')
      },
    },
    methods: {
      tooltipLabelFn(data, label) {
        if (!label) return label
        let week = _.find(data, {label: label})
        if (!week) return label
        return moment(week.start_date).format('LL')
      },
      onWeekChange() {
        let url = `/organization/${this.organization.id}/datacandy/weekly/${this.week_id}`
        this.busy = true
        this.error = null
        axios.get(url)
        .then(response => {
          this.busy = false
          this.weekly = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
        })
      },
    },
    mounted() {
      window.weeklyMonthlyChart = this
      if (this.week_id) this.onWeekChange()
    },
  }
</script>